import { ArrowRight } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import generalDentistryImg from '../../assets/generalDentistryImg.jpg';

const ServiceOverview = ({ overview, serviceName }) => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    return (
        <section
            ref={sectionRef}
            className={`py-16 bg-white transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
            <div className="px-4">
                {/* <h2 className="text-3xl font-bold mb-2 text-teal-600">Service Overview</h2> */}
                {/* <div className="w-24 h-1 bg-lime-500 mb-8"></div> */}

                <div className="bg-gradient-to-br from-teal-50 to-lime-50 rounded-2xl overflow-hidden">
                    <div className="flex flex-col md:flex-row items-center">
                        <div className="md:w-1/2 flex items-center justify-center p-8 bg-gradient-to-br from-teal-100 to-lime-100">
                            <div className="relative w-full max-w-sm">
                                <img
                                    src={generalDentistryImg}
                                    alt={`${serviceName} dental treatment`}
                                    className="rounded-lg shadow-xl z-10 relative"
                                />
                                <div className="absolute -bottom-4 -right-4 w-3/4 h-3/4 bg-lime-200 rounded-lg -z-10"></div>
                            </div>
                        </div>
                        <div className="md:w-1/2 p-8">
                            <p className="text-lg leading-relaxed text-gray-700 text-center">{overview}</p>
                            <div className="mt-8 flex items-center justify-center">
                                <a href="#benefits" className="group flex items-center font-semibold text-teal-600 hover:text-lime-600 transition-colors duration-300">
                                    View Benefits
                                    <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform duration-300" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceOverview;